import { SUPPORTED_LOCALES } from 'root-constants/common'

export const loadLanguageResources = async (lng: string) => {
  try {
    const lang = lng.toLowerCase()

    if (SUPPORTED_LOCALES.includes(lang)) {
      return (await import(`assets/i18n/${lang}.json`)).default
    }

    return (await import('assets/i18n/en.json')).default
  } catch (error) {
    console.error(`Failed to load language ${lng}:`, error)
    throw error
  }
}
